import { S as c, g as d, M as s, a as l } from "./numberInputField-f9611118.mjs";
import { I as q, N as E } from "./numberInputField-f9611118.mjs";
import { jsxs as v, jsx as r } from "react/jsx-runtime";
import { S as f } from "./subtract-848336fd.mjs";
import { IconButton as h } from "./iconButton.js";
import { S as p } from "./types-b577bf77.mjs";
import "react";
import "./index-6a632112.mjs";
import "./warningFilled-691cfde1.mjs";
import "./themes-5f0b3c3d.mjs";
import "./lineHeights-72d3110c.mjs";
import "./screenReaderOnly.js";
import "./button.js";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./accessibility.js";
function u({
  title: t,
  titleId: n,
  size: o,
  height: i,
  width: a,
  ...m
}) {
  const e = o ? p[o] : p.s;
  return /* @__PURE__ */ v(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      height: o ? e : i || e,
      width: o ? e : a || e,
      "aria-labelledby": n,
      ...m,
      children: [
        t ? /* @__PURE__ */ r("title", { id: n, children: t }) : null,
        /* @__PURE__ */ r("g", { clipPath: "url(#Add_svg__a)", children: /* @__PURE__ */ r(
          "path",
          {
            fill: "currentColor",
            d: "M55.8 34.2h-18v-18h-3.6v18h-18v3.6h18v18h3.6v-18h18v-3.6Z"
          }
        ) }),
        /* @__PURE__ */ r("defs", { children: /* @__PURE__ */ r("clipPath", { id: "Add_svg__a", children: /* @__PURE__ */ r("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) }) })
      ]
    }
  );
}
const H = ({
  textSize: t = "medium",
  value: n = 0,
  isDisabled: o = !1,
  isFullyDisabled: i = !1,
  min: a = s,
  accessibilityOptions: m,
  ...e
}) => /* @__PURE__ */ r(
  c,
  {
    variant: "subtract",
    min: a,
    isFullyDisabled: i,
    isDisabled: o,
    value: n,
    textSize: t,
    ...e,
    children: /* @__PURE__ */ r(
      h,
      {
        size: t,
        variant: "ghost",
        icon: /* @__PURE__ */ r(f, { style: d(t), "aria-hidden": !0 }),
        accessibilityOptions: m,
        isDisabled: o || i
      }
    )
  }
), X = ({
  textSize: t = "medium",
  value: n = 0,
  isDisabled: o = !1,
  isFullyDisabled: i = !1,
  max: a = l,
  accessibilityOptions: m,
  ...e
}) => /* @__PURE__ */ r(
  c,
  {
    variant: "add",
    max: a,
    isFullyDisabled: i,
    isDisabled: o,
    value: n,
    textSize: t,
    ...e,
    children: /* @__PURE__ */ r(
      h,
      {
        size: t,
        variant: "ghost",
        icon: /* @__PURE__ */ r(u, { style: d(t), "aria-hidden": !0 }),
        isDisabled: o || i,
        accessibilityOptions: m
      }
    )
  }
);
export {
  H as DecrementStepper,
  q as IncrementSelector,
  X as IncrementStepper,
  E as NumberInputField
};
